import { Center, Loader } from "@mantine/core";
import PreviewHeader from "components/header/PreviewHeader";
import AdminPaymentPreview from "pages/admin/dataEntry/AdminPaymentPreview";
import { useSearchParams } from "react-router-dom";

const PrintPayment: React.FC = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  if (!id)
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  return (
    <div className="inner-container">
      <PreviewHeader />

      <AdminPaymentPreview id={Number(id)} />
    </div>
  );
};

export default PrintPayment;
